/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type AnyAuthzPolicyActionInput = {
  /** 何かフィールドを持つ必要があるのでつけている */
  _dummyField?: boolean | null | undefined;
};

export type AnyAuthzPolicyPrincipalInput = {
  /** 何かフィールドを持つ必要があるのでつけている */
  _dummyField?: boolean | null | undefined;
};

export type AnyAuthzPolicyResourceInput = {
  /** 何かフィールドを持つ必要があるのでつけている */
  _dummyField?: boolean | null | undefined;
};

export type AuthzPolicyActionInput = {
  /** oneof */
  anyAction?: AnyAuthzPolicyActionInput | null | undefined;
  readRoomAction?: ReadRoomAuthzPolicyActionInput | null | undefined;
};

export type AuthzPolicyEffect =
  | 'FORBID'
  | 'PERMIT';

export type AuthzPolicyPrincipalInput = {
  /** oneof */
  anyPrincipal?: AnyAuthzPolicyPrincipalInput | null | undefined;
  staffPrincipal?: StaffAuthzPolicyPrincipalInput | null | undefined;
  teamPrincipal?: TeamAuthzPolicyPrincipalInput | null | undefined;
};

export type AuthzPolicyResourceInput = {
  /** oneof */
  anyResource?: AnyAuthzPolicyResourceInput | null | undefined;
  roomResource?: RoomAuthzPolicyResourceInput | null | undefined;
};

export type CreateAuthzPolicyInput = {
  action: AuthzPolicyActionInput;
  effect: AuthzPolicyEffect;
  name: string;
  principal: AuthzPolicyPrincipalInput;
  resource: AuthzPolicyResourceInput;
};

export type ReadRoomAuthzPolicyActionInput = {
  isAssigned: boolean;
};

export type RoomAuthzPolicyResourceInput = {
  roomID: string | number;
};

export type StaffAuthzPolicyPrincipalInput = {
  staffGUID: string | number;
};

export type TeamAuthzPolicyPrincipalInput = {
  teamGUID: string | number;
};

export type CreateAuthzPolicyMutationVariables = Exact<{
  input: Types.CreateAuthzPolicyInput;
}>;


export type CreateAuthzPolicyMutation = { createAuthzPolicy: { __typename: 'CreateAuthzPolicySuccessPayload' } };


export const CreateAuthzPolicyDocument = gql`
    mutation CreateAuthzPolicy($input: CreateAuthzPolicyInput!) {
  createAuthzPolicy(input: $input) {
    __typename
  }
}
    `;

/**
 * __useCreateAuthzPolicyMutation__
 *
 * To run a mutation, you first call `useCreateAuthzPolicyMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateAuthzPolicyMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateAuthzPolicyMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateAuthzPolicyMutation(options: VueApolloComposable.UseMutationOptions<CreateAuthzPolicyMutation, CreateAuthzPolicyMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateAuthzPolicyMutation, CreateAuthzPolicyMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateAuthzPolicyMutation, CreateAuthzPolicyMutationVariables>(CreateAuthzPolicyDocument, options);
}
export type CreateAuthzPolicyMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateAuthzPolicyMutation, CreateAuthzPolicyMutationVariables>;